import { Box, Card, CardContent, Grid, Skeleton, Stack, Typography } from "@mui/material";
import React from "react";

const ListTypeShimmer = () => {
    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <Box style={{ paddingTop: 20 }}>
                        <Card raised style={{ width: '80%', borderRadius: 10 }}>
                            <CardContent> <Stack direction="column" spacing={3} sx={{ margin: 10, alignItems: "center" }}>
                                <Grid container sx={{ ml: 5 }}>
                                    <Grid item xs sm md>
                                        <Grid container direction="column" >
                                            <Typography variant="h4" justifyContent={'center'} sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rectangular" sx={{
                                                width: { xs: 50, sm: 50, md: 500 },
                                                height: 50,
                                            }} /></Typography>
                                            <Grid container justifyContent='center' sx={{ paddingTop: 5, ml: 8 }}>
                                                <Grid item sm md>
                                                    <Typography variant='h6' sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rounded" width={200} height={25} /></Typography >
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent='space-arround' sx={{ paddingTop: 3, ml: 8 }}>
                                                <Grid item sm={3} md={3}>
                                                    <Typography variant='h6' sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rounded" width={200} height={25} /></Typography >
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent='space-arround' sx={{ paddingTop: 3, ml: 8 }}>
                                                <Grid item sm={3} md={3}>
                                                    <Typography variant='h6' sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rounded" width={200} height={25} /></Typography >
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent='space-arround' sx={{ paddingTop: 3, ml: 8 }}>
                                                <Grid item sm={3} md={3}>
                                                    <Typography variant='h6' sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rounded" width={200} height={25} /></Typography >
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent='space-arround' sx={{ paddingTop: 3, ml: 8, mb: 5 }}>
                                                <Grid item sm md>
                                                    <Typography variant='h6' sx={{ mb: 0.5 }}><Skeleton animation="wave" variant="rounded" width={200} height={25} /></Typography >
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Stack>
                            </CardContent>
                        </Card>

                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default ListTypeShimmer;